export default {
  // common label
  'label.type': 'Type',
  'label.name': 'Name',
  'label.content': 'Content',
  'label.remark': 'Remark',
  'label.createTime': 'Create Time',
  'label.operation': 'Actions',
  'label.code': 'Code',
  'label.date': 'Date',
  'label.title': 'Title',
  'label.status': 'Status',
  'label.department': 'Department',
  'label.endpoint': 'Endpoint',
  'label.username': 'Username',
  'label.unitName': 'UnitName',
  'label.UID': 'UID',
  'label.email': 'Email',
  'label.mobile': 'Mobile',
  'label.yes': 'Yes',
  'label.no': 'No',
  'label.logout': "Logout",
  'label.import': 'Import',
  'label.export': 'Export',
  'label.delete': 'Delete',

  // common button
  'button.search': 'Search',
  'button.reset': 'Reset',
  'button.cancel': 'Cancel',
  'button.save': 'Save',
  'button.import': 'Import',
  'button.export': 'Export',
  'button.add': 'Add',
  'button.submit': 'Submit',
  'button.ok': 'OK',
  'button.synchronize': 'Synchronize',
  'button.confirm': 'Confirm',
  'button.delete': 'Delete',
  'button.details': 'Details',
  'button.edit': 'Edit',

  // common message
  'message.add': 'Add Successfully.',
  'message.edit': 'Save Successfully.',
  'message.delete.confirm': 'Are you sure to delete this record?',
  'message.delete.success': 'Delete record success.',
  'message.rule': 'field format is wrong。',
  'message.read.success': 'Operate Successful.',
  'message.async.title': 'Are you sure to synchronize permissions?',
  'message.async.success': 'Synchronize Successful',
  'message.back': 'Back to home',

  // table label
  'label.table.title': 'The result include',
  'label.table.items': 'items',
  'label.table.edit': 'Edit',
  'label.table.delete': 'Delete',
  'label.table.detail': 'Detail',
  'label.table.permission': 'Permission',
  'label.permission': 'Button Permissions',
  // placeholder
  'placeholder.select': 'Please Select',
  'placeholder.input': 'Please Input',
  'placeholder.Startdate': 'Start date',
  'placeholder.Enddate': 'End date',
  'placeholder.StartMonth': 'Start month',
  'placeholder.EndMonth': 'End month',

  // Audit
  'label.audit.detail': 'Audit Detail',

  'column.title': 'xiugai',
  // Delegation
  'label.delegation.id': 'Delegate UID',
  'label.delegation.name': 'Delegate Name',
  'label.delegation.list': 'Delegate List',
  'label.delegation.startDate': 'Start Date',
  'label.delegation.endDate': 'End Date',
  'label.delegation.add': 'Add Delegation',
  'label.delegation.edit': 'Edit Delegation',

  'label.delegation.authorizer.id': 'Authorizer UID',
  'label.delegation.authorizer.name': 'Authorizer  Name',

  'rule.delegation.id': 'Delegation id can not be empty!',
  'rule.delegation.startTime': 'Start time can not be empty!',
  'rule.delegation.endTime': 'End time can not be empty!',

  // Dict
  'label.dict.table': 'Dict table',
  'label.dict.key': 'Key',
  'label.dict.cn': 'CN',
  'label.dict.en': 'EN',
  'label.dict.add': 'Add Dict',
  'label.dict.edit': 'Edit Dict',
  'label.table.notes': 'Notes',
  'rule.dict.code': 'Please input dict code',
  'rule.dict.name': 'Please input dict name',

  // Notification
  'label.notification.handle': 'Link',
  'label.notification.ignore': 'Mark read',
  'label.notification.read': 'Read',
  'label.notification.unread': 'Unread',
  'label.notification.clear': 'All Read',
  'label.notification.more': 'More',

  // Department
  'label.department.title': 'View Department',
  'label.department.unit.name': 'Unit name',
  'label.department.unit.id': 'Unit id',
  'label.department.short.name': 'Short name',
  'label.department.parent.id': 'Parent id',

  // permission
  'label.permission.name': 'Permission Name',
  'label.permission.code': 'Permission Code',
  'label.permission.action': 'Permission Action',
  'label.permission.data': 'Data Permissions',
  'label.permission.title': 'Permissions',
  'label.permission.description': 'Permission Description',

  // Role
  'label.role.code': 'Role Code',
  'label.role.name': 'Role Name',
  'label.role.isGlobal': 'Global Role',
  'label.role.enabled': 'Enabled',
  'label.role.disabled': 'Disabled',
  'label.role.description': 'Role Description',
  'label.role.add': 'Add role',
  'label.role.edit': 'Edit role',
  'label.role.permission': 'Edit permission',

  'rule.role.code': 'Role code can not be empty!',
  'rule.role.name': 'Role name can not be empty!',
  'rule.role.model': 'Company can not be empty!',

  // user
  'label.user.add': 'Add user',
  'label.user.edit': 'Edit user',
  'label.user.roles': 'Role List',

  'rule.user.name': 'Username can not be empty!',
  'rule.user.uid': 'Uid can not be empty!',
  'rule.user.deptCode': 'DepartmentName can not be empty!',
  'rule.user.email': 'Email can not be empty!',
  'rule.user.email.type': 'Incorrect email format!',
  'rule.user.mobile': 'Mobile can not be empty!',
  'rule.user.mobile.type': 'Incorrect phone number format!',

  // container
  'label.menu.search': 'Search Panel',
  'label.menu.table': 'Data List',
  'label.menu.close': 'Close',
  'label.menu.open': 'Expand',
  // job manager

  'label.jobManager.jobName': 'JobName',
  'label.jobManager.jobGroup': 'JobGroup',
  'label.jobManager.cron': 'Cron',
  'label.jobManager.description': 'Description',
  'label.jobManager.status': 'Status',
  'label.jobManager.misfireType': 'Misfire Type',
  'label.jobManager.schedulerJobStatus': 'Job Running Status',
  'button.jobManager.delete': 'delete',
  'button.jobManager.pause': 'pause',
  'button.jobManager.resume': 'resume',
  'button.jobManager.runOnce': 'run once',
  'label.jobManager.add': 'Add Job',
  'rule.jobManager.jobName': 'JobName is required!',
  'rule.jobManager.jobGroup': 'JobGroup is required!',
  'rule.jobManager.cron': 'Cron is required!',
  'rule.jobManager.misfireType': 'Misfire Type is required!',
  'rule.jobManager.status': 'Status is required!',
  'rule.jobManager.jobMapKey': 'Key is required!',
  'rule.jobManager.jobMapValue': 'Value is required!',
  'label.jobManager.enabled': 'enabled',
  'label.jobManager.disabled': 'disabled',
  'label.jobManager.jobMaps': 'job map',
  'label.jobManager.misfireType.MISFIRE_INSTRUCTION_IGNORE_MISFIRE_POLICY': 'MISFIRE_INSTRUCTION_IGNORE_MISFIRE_POLICY',
  'label.jobManager.misfireType.MISFIRE_INSTRUCTION_FIRE_ONCE_NOW': 'MISFIRE_INSTRUCTION_FIRE_ONCE_NOW',
  'label.jobManager.misfireType.MISFIRE_INSTRUCTION_DO_NOTHING': 'MISFIRE_INSTRUCTION_DO_NOTHING',
  'message.jobManager.add': 'Add Successfully.',
  // menu
  'menu.home': 'Home',
  'menu.system': 'BCS Custom',
  'menu.system.rbac': 'RBAC',
  'menu.rbac.user': 'User',
  'menu.rbac.role': 'Role',
  'menu.rbac.permission': 'Permission',
  'menu.rbac.department': 'Department',
  'menu.system.notification': 'Notification',
  'menu.system.syslog': '操作日志',
  'menu.system.dictionary': 'Data Dictionary',
  'menu.system.audit': 'Audit',
  'menu.system.delegation': 'Delegation',
  'menu.system.notFound': 'Not Found',
  'menu.system.customs': 'Parts Declaration',
  'menu.cus.rack': 'RACK Tracking',
  'menu.system.jobManager': 'Job Manager',
  'menu.system.homgpage': 'BCS关务模块',
  'menu.system.dpcard': '危包证追踪',
  'menu.dpcard.ledger': '工厂包装信息确认',
  'menu.dpcard.tocq': '危包证追踪',
  'menu.system.dgcbusiness': '危包证业务',
  'menu.system.filemg': '文件管理',
  'menu.filemg.filemg': '文件管理',
  'menu.filemg.dpEPart': '文件上传',
  'menu.filemg.dpSeach': '文件查询',
  'menu.filemg.pdoc': '性能单管理',
  'menu.filemg.dpInspledger': '查验台账',
  'menu.filemg.dpFReport': '厂检报告1',
  'menu.system.psettings': '参数设置',
  'menu.psettings.dppqconfig': '包装-零件参数设置',
  'menu.system.fta': 'Certificate of Origin Operations',
  'menu.system.dpexport': 'Certificate of Origin Declaration',
  'menu.dpexport.dpEPart': 'CoO Certificate Mgmt.',
  'menu.dpexport.dpEBasic': 'Declaration Master Data',
  'menu.dpexport.dpTJP': 'TJP Data',
  'menu.dpexport.dpTJPDetails': 'TJP接口数据详情',
  'menu.dpexport.dpEBasicDetails': '申报基础数据详情',
  'menu.dpexport.Uploadlogs': '上传日志',
  'menu.dpexport.new': 'newly added',
  'menu.dpexport.edit': '编辑',
  'menu.dpexport.details': '原产地证-详情',
  'menu.dpexport.dptoconfigure': '原产地证类型配置',
  'menu.dpexport.exchange': '征税汇率表',
  'menu.dpexport.dptocondeclare': 'CoO Application Documents',
  'menu.dpexport.dptoconadministration': 'CoO Template Mgmt.',
  'menu.system.dpShipNoCertificate': '危包证申请',
  'menu.dpShipNoCertificate.dpShipNotice': '工厂出货通知',
  'menu.dpShipNoCertificate.dpGoodsCert': '危包证申请',
  'menu.system.partnermanagement': '合作伙伴管理',
  'menu.partnermanagement.partner': '合作伙伴管理',
  'menu.system.partsmanagement': 'Parts Management',
  'menu.partsmanagement.parts': 'Parts Management Overview',
  'menu.partsmanagement.partsbom': 'Cost Certificate Mgmt.',
  'menu.partsmanagement.details': '零件产品成本明细-详情',
  'menu.partsmanagement.detailsbom': '零件产品成本明细-详情',
  'menu.partsmanagement.ftastatement': 'Statement on Origin Mgmt.',
  'menu.system.prereview': 'Pre-qualification Data Management',
  'menu.prereview.administration': 'Pre-qualification Data Mgmt.',
  'menu.prereview.partsdetails': 'Parts Associated  with Pre-qualifed Parts',
  'menu.prereview.partsdbometails': '零件产品成本明细-详情',
  'menu.prereview.historicalformation': 'Historical Pre-qualification Data',
  'menu.prereview.historicaldetails': 'Historical Pre-qualification Parts List',
  'menu.prereview.details': '预审信息-详情',
  'menu.prereview.maintenancedetails': '预审信息-申请单号维护',
  'menu.system.settingstype': '系统设置',
  'menu.settingstype.syslog': '操作日志',
  'menu.settingstype.check': '校验设置',
  'menu.prereview.bometails': '零件产品成本明细-详情',
  'menu.prereview.historytails': '历史预审信息-详情',
  'menu.prereview.historybomtails': '零件产品成本明细-详情',
  'menu.prereview.historiesbomtails': '零件产品成本明细-详情',
  'menu.system.datareview': 'Data Review',
  'menu.datareview.reviewbom': 'Pre-qualification Parts Review',
  'menu.datareview.resultdetails': 'Part Verification Records',
  'menu.datareview.ledger': 'Inspection Ledger',
  'menu.datareview.bometails': '零件产品成本明细-详情',
  'menu.datareview.bomed': '零件产品成本明细-详情',
  'menu.datareview.bomeq': '预审信息详情',
  'menu.datareview.reviewresults': 'Review Results',
  'menu.datareview.ledgers': 'Sampling Inspection Record',
  'menu.datareview.reviewresultsbom': '复核结果零件产品成本明细-详情',
  'menu.datareview.frequency': 'Review Frequency Setting',
  'menu.system.onlineStamp': '电子章',
  'menu.onlineStamp.exemptionInfos': 'exemption management',
  'menu.system.exportFileReviewLedger': '出口文件复核台账',
  'menu.system.documentseal': '出口文件盖章',
  'menu.system.fileUploadlogs': '出口文件上传日志',
  'menu.system.goods': '危包文件盖章',
  'menu.system.reImportDocumentStamping': '复进口文件盖章',
  'menu.system.reImportReviewLedger': '复进口文件复核台账',
  'menu.system.stampPosition': '盖章位置配置',
  'label.InvoiceNO': 'Invoice NO.',
  'label.CDF': 'CDF',
  'label.Expiredate': 'Expire date',
  'label.CDD': 'CDD',
  'label.ReturnCDD': 'Return-CDD',
  'label.Alertdate': 'Alert date',
  'label.CarModel': 'Car Model',
  'label.WaybillNO': 'Waybill NO.',
  'label.Type/LOT': 'Type/LOT',
  'label.ContainerNO': 'Container NO.',
  'label.CDFNO': 'CDF NO.',
  'label.ReturnWaybillNO': 'Return-Waybill NO.',
  'label.ReturnContainerNO': 'Return-Container NO.',
  'label.ReturnCDFNO': 'Return-CDF NO.',
  'label.Return': 'Return Batch',
  'label.PartNO': 'Part NO.',
  "label.ExportReviewResult": 'Export Review Result',
  "label.ReturnImportReviewResult": 'Return Import Review Result',
  "label.ExportResult": 'Export Review',
  "label.ReturnResult": 'Import Review',
  'label.Notes': 'Notes',
  "label.DescriptionEN": "Description (EN)",
  "label.DescriptionCN": 'Description (CN)',
  "label.DataStatus": "Data Status",
  "label.singinid": "SIGNI ID",
  "label.SerialNumber": 'Serial Number',
  "label.DownloadTemplate": 'Download Template',
  "label.UpdateBatch": 'Update Batch',
  "label.MarkasCompleted": 'Mark as Completed',
  "label.Delete": 'Delete',
  'label.onlineStamp.exemptionInfos.exemptionName': '豁免名称',
  'label.onlineStamp.exemptionInfos.exemptionId': '豁免ID',
  'label.onlineStamp.exemptionInfos.exemptionType': '豁免类型',
  'label.onlineStamp.exemptionInfos.effectiveDate': '生效日期',
  'label.onlineStamp.exemptionInfos.expiryDate': '失效日期',
  'label.onlineStamp.exemptionInfos.remark': '备注',


  'menu.dpexport.billmanagement': 'B/L Mgmt.',
  'menu.system.taxSaving': '节税报表',
  'menu.taxSaving.taxSavingPayableRateSetting': '应缴税率维护',
  'menu.taxSaving.TaxSavingReport': '节税报表',

  'menu.system.temporaryIE': '暂时进出口业务',
  'menu.temporaryIE.tieExtensionRecord': '延期记录',
  'menu.temporaryIE.goodsQuantityConfig': '货物数量配置',
  'menu.temporaryIE.cusExportDraft': '出口报关单草单管理',
  'menu.temporaryIE.fileUploadlogs': '出口报关单草单管理-上传日志',
  'menu.temporaryIE.temporaryieLedgerDetails':'暂时进出口台账',
  'menu.temporaryIE.temporaryieDocumentSummary':'暂时进出口文件汇总',

  //Fta
  'label.fta.management.AiPartNo': "AI Part No.",
  Fta: {
    // 通用占位符 (如果您的项目中还没有)
    placeholder: {
      input: 'Please Input',
      select: 'Please Select',
    },
    // 通用按钮 (如果您的项目中还没有)
    button: {
      search: 'Search',
      reset: 'Reset',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
    // 通用标签 (如果您的项目中还没有)
    label: {
      operation: 'Actions',
      table: {
        edit: 'Edit',
      },
    },

    partsMgmt: {
      // 搜索面板 (基于图片和代码)
      search: {
        aiPartNo: 'Part No. with AI',
        proposedHSCode: 'Suggested HS Code',
        supplier: 'Supplier',
        partNameCn: 'Part description (CN)', // 零件名称（中文）
        partNameEn: 'Part description (EN)', // 零件名称（英文）
        isOrigin: 'Origin Status', // 是否原产 对应 Origin Status
        partStatus: 'Part Status',
        preAuditInfoStatus: 'Pre-qualification Status', // 预审信息状态 对应 Pre-Cert Status
      },

      // 顶部操作按钮 (基于图片和代码)
      button: {
        partsSync: 'Part Sync',
        byVehicleModel: 'By Vehicle Model',
        byAIPartNo: 'By AI Part No.',
        add: 'Add',
        importParts: 'Import Parts',
        notifyToUploadCostCertificate: 'Notify to Upload Cost Certificate',
        importHSCode: 'Import HS Code',
        generatePreAuditInfo: 'Generate Pre-qualification Info.', // 生成预审信息 对应 Generate Pre-Certification
        batchGeneratePreAuditInfo: 'Batch Generate Pre-qualification Info.', // 生成预审信息 对应 Generate Pre-Certification
        partStatusToggle: 'Part Status Toggle',
        delete: 'Delete',
      },

      // 表格列标题 (基于图片和代码)
      table: {
        preAuditInfoStatus: 'Pre-qualification Status',
        partStatus: 'Part Status',
        vehicleModel: 'Vehicle Model', // 车型 对应 Vehicle Platform
        partNo: 'Part No.',
        aiVersion: 'AI Version',
        aiPartNo: 'Part No. with AI',
        partNameCn: 'Part Description (CN)',
        partNameEn: 'Part Description (EN)',
        supplier: 'Supplier (CN)',
        supplierEn: 'Supplier (EN)',
        suggestedHSCode: 'Suggested HS Code',
        nonOriginBomPercent: 'Percentage of Non-originating Material-Cost Certificate', // 非原产成分-成本证明(%)
        costCertificateConfirmed: 'Cost Certificate Version', // 成本证明-已确认 对应 Cost Certificate
        nonOriginPreAuditPercent: 'Percentage of Non-originating Material-Pre-qualification',
        preAuditRequestNo: 'Pre-qualification ID',
        isOrigin: 'Origin Status',
        isRVCApplicable: 'RVC_eligibility [Y/N]', // 是否适用RVC
        isCTCApplicable: 'CTC_eligibility [Y/N]', // 是否适用CTC
        originStandard: 'Criteria of Origin', // 原产地标准 对应 Origin Criterion
        originSubStandard: 'Criteria of Sub-origin', // 原产地子标准 对应 Origin Sub-Criterion
      },

      // 工具提示
      tooltip: {
        nonOriginFOB: "'Non-Origin Content' refers to the non-origin percentage of FOB; RVC standard is BCS customized RVC standard.",
      },

      // 弹窗
      dialog: {
        syncPartsInfo: {
          title: 'Sync Part Information',
          tip1: 'After selecting the vehicle model, all part numbers of this model in "Material" will be synchronized to Parts Management.',
          tip2: 'The result of part information synchronization will be notified to you via email, no need to stay on the current page.',
          tip3: 'Please do not repeat the operation before receiving the notification email.',
          vehicleModel: 'Vehicle Model',
        },
      },
    },
    // === 2. 成本证明管理 (Cost Cert Mgmt) 模块 ===
    costCertMgmt: {
      // 页面标题 (基于截图)
      title: 'Cost Certificate Mgmt.',

      // 搜索面板 (基于截图和代码)
      search: {
        aiPartNo: 'Part No. with AI',
        cnDescription: 'Part Description (CN)',
        complianceCheck: 'Cost Certificate Self-verification Status',
        dataStatus: 'Data Status',
        enDescription: 'Part description (EN)',
        supplier: 'Supplier',
        bcsRvcCompliance: 'BCS-RVC Eligibility',
      },

      // 顶部操作按钮 (基于截图和代码)
      button: {
        importCostCertificate: 'Import Cost Certificate',
        dataValidation: 'Data Self-verification',
        validateAndConfirm: 'Confirm',
        delete: 'Delete',
        export: 'Export',
        exportBaseInfo: 'Export Base Info',
        exportCostCertDetail: 'Export Cost Certificate Detail',
        downloadZipFile:'批量下载成本证明'
      },

      // 表格列标题 (基于截图和代码)
      table: {
        vehiclePlatform: 'Vehicle Model',
        partNo: 'Part No.',
        aiVersion: 'AI Version',
        aiPartNo: 'Part No. with AI',
        cnDescription: 'Part description (CN)',
        enDescription: 'Part description (EN)',
        drawingNo: 'Drawing No.',
        supplier: 'Supplier (CN)',
        supplierEn: 'Supplier (EN)',
        version: 'Version',
        dataStatus: 'Data Status',
        validationResult: 'Self-verification Result',
        bcsRvcCompliance: 'BCS-RVC Eligibility',
        nonOriginatingMaterials: 'Non-originating Materials / FOB price (%)',
        confirmationDate: 'Confirmation Time',
        details: 'Details',
        viewFile: 'View File',
      },

      // 弹窗
      dialog: {
        systemTip: {
          title: 'System Tip',
          tip1: 'Confirm to proceed with the self-check of part product cost details?',
          tip2: 'The system will execute the self-check logic in the background, and the result will be displayed in the "Validation Result" column.',
        },
        validationTip: {
          title: 'Validation Tip',
          selfProject: 'Self-Check Item',
          systemCalc: 'System Calculation',
          userCalc: 'User Reporting',
          validationResult: 'Validation Result',
        },
      },
    },
    // === 3. 原产声明管理 (Origin Declaration Mgmt) 模块 ===
    originDeclMgmt: {
      // 页面标题 (基于截图)
      title: 'Statement on Origin Mgmt.',

      // 搜索面板
      search: {
        aiPartNo: 'Part No. with AI',
        fileStatus: 'File Status',
        supplier: 'Supplier',
        fileType: 'File Type',
      },

      // 顶部操作按钮
      button: {
        uploadFile: 'Upload Document',
        bulkUploadFile: 'Bulk Upload',
        uploadLog: 'Upload Log',
        sendReviewNotice: 'Send for Review',
        fileReview: 'Document Review',
        sendReviewResultNotice: 'Notify Review Result',
      },

      // 表格列标题
      table: {
        dataStatus: 'Data Status',
        fileStatus: 'File Status',
        aiPartNo: 'AI Part No.',
        partNameEn: 'Part description (EN)',
        partNameCn: 'Part description (CN)',
        version: 'Version',
        supplier: 'Supplier (CN)',
        supplierEn: 'Supplier (EN)',
        isOrigin: 'Origin Status',
        originRule: 'Rules of Origin',
        fileType: 'File Type',
        fileName: 'File Name',
        auditRecord: 'Review Records',
      },

      // 弹窗
      dialog: {
        uploadTip: {
          title: 'System Tip',
          tip1: 'An Origin Declaration already exists for the current pre-certification information. Re-uploading the file will replace the current declaration.',
          tip2: 'Are you sure you want to continue uploading the file?',
        },
        reviewNotice: {
          title: 'System Tip',
          tip1: 'Clicking [Confirm] will email a notice to BCS Customs for file review, and the selected files will become unchangeable.',
          tip2: 'Confirm sending the review notification?',
        },
        reviewResultNotice: {
          title: 'System Tip',
          tip1: 'Clicking [Confirm] will email the file review result to the supplier.',
          tip2: 'Confirm sending the review result notification?',
        },
        replaceFileTip: {
          title: 'Tip',
          tip: 'The selected data already has an Origin Declaration/Statement of Fact. Re-uploading the file will replace the current file. Confirm to continue uploading?',
        },
      },
    },
    // === 4. 预审信息管理 (Pre-Certification Mgmt) 模块 ===
    preCertMgmt: {
      // 页面标题 (基于截图)
      title: 'Pre-qualification Data Mgmt.',

      // 搜索面板
      search: {
        suggestedHSCode: 'Suggested HS Code',
        productNameCn: 'Product Name (CN)',
        supplier: 'Supplier',
        dataStatus: 'Pre-qualification Data Status',
        preCertGenerationDate: 'Pre-qualification Generation Date',
        filingDate: 'Filing Date',
        singleWindowApplicationNo: 'Single Window Application No.',
      },

      // 顶部操作按钮
      button: {
        updateRecParts: 'Update Recommended Parts',
        notifyPreCert: 'Notify Pre-Certification',
        confirmPreCert: 'Confirm Pre-qualification Info.',
        delete: 'Delete',
        changeNameHSCode: 'Change Name/HS Code',
        export: 'Export',
      },

      // 表格列标题
      table: {
        dataStatus: 'Pre-qualification Status',
        singleWindowApplicationNo: 'Single Window Application No.',
        filingDate: 'Filing Date',
        productNameCn: 'Product Name (CN)',
        suggestedHSCode: 'Suggested HS Code',
        supplier: 'Supplier (CN)',
        supplierEn: 'Supplier (EN)',
        nonOriginatingMaterials: 'Non-originating Materials / FOB price (%)',
        recommendedAIPartNo: 'Recommended Part No.with Al',
        rulesOfOrigin: 'Rules of Origin',
        partCount: 'Parts Count',
        notificationSendTime: 'Notification Time',
        preCertGenerationDate: 'Pre-qualification Info.Generation Date',
        details: 'Details',
        editApplicationNo: 'Edit Application No.',
        viewFile: 'View File',
      },

      // 弹窗
      dialog: {
        uploadTip: {
          title: 'System Tip',
          tip1: 'An Origin Declaration already exists for the current pre-certification information. Re-uploading the file will replace the current declaration.',
          tip2: 'Are you sure you want to continue uploading the file?',
        },
        changeNameHSCodeTip: {
          title: 'System Tip',
          tip1: 'Are you sure you want to change the selected Pre-Certification information?',
          tip2: 'After initiating the change process, Part Classification, Cost Certificate Upload, and the entire product pre-certification process must be restarted. Related part numbers cannot apply for Certificates of Origin during this period.',
        },
      },
    },
    // === 5. 预审关联零件详情 (Pre-Certification Related Part Details) 模块 ===
    preCertRelParts: {
      // 页面标题 (基于截图)
      title: 'Pre-Certification Related Part Details',

      // 搜索面板
      search: {
        aiPartNo: 'Part No. with AI',
        partNameCn: 'Part description (CN)',
        supplier: 'Supplier',
        dataStatus: 'Data Status',
        suggestedHSCode: 'Suggested HS Code',
        singleWindowApplicationNo: 'Single Window Application No.',
        preCertGenerationDate: 'Pre-qualification Info.Generation Date',
        isRecommended: 'Recommended Part No.with Al',
      },

      // 表格列标题
      table: {
        dataStatus: 'Data Status',
        singleWindowApplicationNo: 'Single Window Application No.',
        isRecommended: 'Recommended  Part No.with Al',
        aiPartNo: 'Part No. with AI',
        version: 'Version',
        partNameCn: 'Part description (CN)',
        partNameEn: 'Part description (EN)',
        suggestedHSCode: 'Suggested HS Code',
        supplier: 'Supplier (CN)',
        supplierEn: 'Supplier (EN)',
        nonOriginatingMaterials: 'Non-originating Materials / FOB price (%)',
        preCertGenerationDate: 'Pre-qualification Info.Generation Date',
        details: 'Details',
      },
    },
    // === 6. 预审历史 (Pre-Certification History) 模块 ===
    preCertHist: {
      // 页面标题 (基于截图)
      title: 'Pre-Certification History',

      // 搜索面板
      search: {
        suggestedHSCode: 'Suggested HS Code',
        productNameCn: 'Product Name (CN)',
        supplier: 'Supplier',
        preCertGenerationDate: 'Pre-qualification Info.Generation Date',
        filingDate: 'Filing Date',
        singleWindowApplicationNo: 'Single Window Application No.',
      },

      // 表格列标题
      table: {
        singleWindowApplicationNo: 'Single Window Application No.',
        filingDate: 'Filing Date',
        productNameCn: 'Product Name (CN)',
        suggestedHSCode: 'Suggested HS Code',
        supplier: 'Supplier (CN)',
        supplierEn: 'Supplier (EN)',
        nonOriginatingMaterials: 'Non-originating Materials / FOB price (%)',
        recommendedPartNo: 'Recommended Part No.with Al',
        partCount: 'Parts Count',
        rulesOfOrigin: 'Rules of Origin',
        notificationSendTime: 'Notification Time',
        preCertGenerationDate: 'Pre-qualification Info.Generation Date',
        details: 'Details',
        viewFile: 'View File',
      },

      // 弹窗
      dialog: {
        selfCheckTip: {
          title: 'System Tip',
          tip1: 'Confirm running a self-check on the Part Product Cost Details?',
          tip2: 'The system will execute the self-check logic in the background, and the result will be displayed in the "Self-Check Status" column.',
        },
      },
    },
    // === 7. 历史零件详情 (Historical Part Details) 模块 ===
    histPartDetails: {
      // 页面标题 (基于截图)
      title: 'Historical Part Details',

      // 搜索面板
      search: {
        aiPartNo: 'Part No. with AI',
        partNameCn: 'Part description (CN)',
        supplier: 'Supplier',
        suggestedHSCode: 'Suggested HS Code',
        singleWindowApplicationNo: 'Single Window Application No.',
        isRecommended: 'Recommended Part No.with Al',
        preCertGenerationDate: 'Pre-qualification Info.Generation Date',
      },

      // 表格列标题
      table: {
        singleWindowApplicationNo: 'Single Window Application No.',
        isRecommended: 'Recommended Part No.with Al',
        aiPartNo: 'Part No. with AI',
        version: 'Version',
        partNameCn: 'Part description (CN)',
        partNameEn: 'Part description (EN)',
        suggestedHSCode: 'Suggested HS Code',
        supplier: 'Supplier (CN)',
        supplierEn: 'Supplier (EN)',
        nonOriginatingMaterials: 'Non-originating Materials / FOB price (%)',
        preCertGenerationDate: 'Pre-qualification Info.Generation Date',
        details: 'Details',
      },

      // 弹窗
      dialog: {
        selfCheckTip: {
          title: 'System Tip',
          tip1: 'Confirm running a self-check on the Part Product Cost Details?',
          tip2: 'The system will execute the self-check logic in the background, and the result will be displayed in the "Self-Check Status" column.',
        },
        selfCheckDetails: {
          title: 'System Tip',
          checkItem: 'Check Item',
          systemCalculation: 'System Calculation',
          userReport: 'User Report',
          checkResult: 'Check Result',
        },
      },
    },
    // === 8. 零件复核记录 (Part Verification Records) 模块 ===
    partVerifyRec: {
      // 页面标题 (基于截图)
      title: 'Part Verification Records',

      // 搜索面板
      search: {
        supplier: 'Supplier',
        recordCreationTime: 'Review Record Creation Time',
        costCertChanged: 'Whether Cost Certificate Changed',
        verificationMethod: 'Review Method',
      },

      // 表格列标题
      table: {
        recordCreationTime: 'Review Record Creation Time',
        verificationStatus: 'Review Status',
        verificationMethod: 'Review Method',
        verificationDate: 'Review Date',
        verifiedBy: 'Reviewed By',
        supplier: 'Supplier (CN)',
        supplierEn: 'Supplier (EN)',
        totalVerifiedParts: 'Total Reviewed Parts',
        partsWithChanges: 'Parts with Changes',
        startVerification: 'Start Verification',
        viewDetails: 'Review Results',
      },
    },
    // === 9. 零件复核详情 (Part Verification Details) 模块 ===
    partVerifyDetails: {
      // 页面标题 (基于截图)
      title: 'Part Verification Details',

      // 按钮
      button: {
        batchQuery: 'Bulk Search',
      },

      // 搜索面板
      search: {
        supplier: 'Supplier',
        aiPartNo: 'Part No. with AI',
        costCertChanged: 'Whether Cost Certificate Changed',
        isCertificate: 'Whether Certificate Created',
        partNameCn: 'Part description (CN)', // Assuming Part Name (CN) is CN Description in English context
        recordCreationTime: 'Review Record Creation Time',
      },

      // 表格列标题和相关内容
      table: {
        recordCreationTime: 'Review Record Creation Time',
        supplier: 'Supplier (CN)',
        supplierEn: 'Supplier (EN)',
        aiPartNo: 'Part No. with AI',
        partNameCn: 'Part description (CN)',
        suggestedHSCode: 'Suggested HS Code ',
        costCertChanged: 'Whether Cost Certificate Changed',
        isRVCApplicable: 'RVC_eligibility [Y/N]',
        isCTCApplicable: 'CTC_eligibility [Y/N]',
        isCertificate: 'Whether Certificate Created',
        originStandard: 'Criteria of Origin',
        originSubStandard: 'Criteria of Sub-origin',
        auxiliaryItems: 'Supporting items',
        reviewVersion: 'Review Version',
        updateVersion: 'Update Version',
        nonOriginatingMaterials: 'Non-originating Materials / FOB price (%)',
        viewCertLogic: 'Click to view "Whether Certificate Created" logic',
        tooltipContent: 'If the Cost Certificate for the part has changed during this verification, the data list displays the origin rule judgment result based on the latest Cost Certificate for the AI Part No.; otherwise, it displays the result based on the verified version.',
      },

      // 弹窗
      dialog: {
        originDeclarationTip: {
          title: 'System Tip',
          tip1: 'An Origin Declaration already exists for the current pre-certification information. Re-uploading the file will replace the current Origin Declaration.',
          tip2: 'Are you sure you want to proceed with uploading the file?',
        },
        certLogic: {
          title: '"Whether Certificate Created" Logic Explanation',
          originStatusTable: 'Origin Status Table',
          dataReviewOriginResult: 'Data Review Origin Judgment Result',
          isRVCApplicable: 'RVC eligibility',
          isCTCApplicable: 'CTC applicability',
          isCertificate: 'Whether Certificate Created',
        },
        batchQuery: {
          title: 'Batch Query',
          aiPartNo: 'Part No. with AI',
          partNameCn: 'Part description (CN)',
          placeholder: 'Please enter separated by new lines or commas (,)',
        },
      },
    },
    // === 10. 抽检台账 (Inspection Ledger) 模块 ===
    inspectionLedger: {
      // 页面标题 (基于截图)
      title: 'Inspection Ledger',

      // 搜索面板
      search: {
        supplier: 'Supplier',
        inspectionDate: 'Inspection Date',
      },

      // 表格列标题和操作
      table: {
        inspectionStatus: 'Inspection Status',
        inspectedSupplier: 'Supplier (CN)',
        inspectedSupplierEn: 'Supplier (EN)',
        inspectionDate: 'Inspection Date',
        inspectionOfficer: 'Inspection Operator',
        attachmentCount: 'Attachment Count',
        uploadAttachment: 'Upload Attachments',
        viewFile: 'View File',
      },

      // 弹窗
      dialog: {
        originDeclarationTip: {
          title: 'System Tip',
          tip1: 'An Origin Declaration already exists for the current pre-certification information. Re-uploading the file will replace the current Origin Declaration.',
          tip2: 'Are you sure you want to proceed with uploading the file?',
        },
        changePartHS: {
          title: 'System Tip',
          tip1: 'Are you sure you want to change the selected pre-certification information?',
          tip2: 'After initiating the change process, you will need to restart part classification, upload part product cost details, and re-undergo the commodity pre-certification process. During this period, relevant part numbers cannot be used to apply for a Certificate of Origin.',
        },
      },
    },
    reviewFreqConfig: {
      title: 'Review Frequency Configuration',
      search: {
        operator: 'Operator',
      },
      table: {
        unit: 'Review Frequency Unit',
        frequency: 'Review Frequency',
        notificationDate: 'Review Notification Sent Date',
        remarks: 'Remarks',
        operator: 'Operator',
        operationTime: 'Operation Time',
      },
      dialog: {
        systemTip: 'System Notification',
        originDeclTip1: 'An Origin Declaration already exists for this pre-audit info. Re-uploading will replace the current file.',
        originDeclTip2: 'Are you sure you want to continue uploading?',
        changeTip1: 'Are you sure you want to change the selected pre-audit information?',
        changeTip2: 'After initiating the change process, part classification and cost detail uploads must be restarted. During this period, relevant part numbers cannot apply for CO.',
      }
    },
    declMasterData: {
      search: {
        proformaInvNo: 'Proforma Invoice No.',
        dataStatus: 'Data Status',
        signiId: 'SIGNI ID',
        bolNo: 'B/L No.',
        shipmentDate: 'Shipment Departure Date',
        proformaInvDate: 'Proforma Invoice Date',
      },
      button: {
        batchUploadEdi: 'Batch Upload EDI',
        uploadLog: 'Upload Log',
        importSigniId: 'Import SIGNI ID',
        importAiPartNo: 'Import Part No. with AI',
        importBolInfo: 'Import B/L',
        generateCoo: 'Generate CoO Certificate',
        bolMaintenance: 'B/L Maintenance',
        skipAndGenerate: 'Skip invoices above and continue',
      },
      table: {
        status: 'Status',
        proformaInvNo: 'Proforma Invoice No.',
        commercialInvNo: 'Commercial Invoice No.',
        commercialInvDate: 'Commercial Invoice Date',
        proformaInvDate: 'Proforma Invoice Date',
        signiId: 'SIGNI ID',
        bolNo: 'B/L No.',
        shipmentDate: 'Shipment Departure Date',
        vesselVoyage: 'Vessel/Voyage No.',
        certNo: 'Certificate No.',
        creationTime: 'Creation Time',
      },
      dialog: {
        systemTip: 'System Notification',
        selfCheckTitle: 'Self-check Notification',
        selfProject: 'Self-check Item',
        systemCalc: 'System Calculation',
        userCalc: 'User Reporting',
        selfResult: 'Self-check Result',
        verifyTip: 'Necessary accompanying documents for the following Proforma Invoice numbers are incomplete. Certificate of Origin cannot be generated. Please complete and retry.',
        missingDoc: 'Missing Accompanying Document',
      }
    },
    cooAppDocs: {
      search: {
        proformaInvNo: 'Proforma Invoice No.',
        signiId: 'SIGNI ID',
      },
      button: {
        viewFile: 'View File',
      },
      table: {
        proformaInvNo: 'Proforma Invoice No.',
        signiId: 'SIGNI ID',
        proformaInv: 'Proforma Invoice',
        packingList: 'Packing List',
        contract: 'Contract',
        bol: 'B/L',
        originalCoo: 'Original CoO Certificate',
        thirdPartyInv: 'Third Party Invoice (Non-Party)',
        exportDecl: 'Export Customs Declaration Form (e copy)',
        costStatement: 'Product Cost Certificate',
        purchaseCert: 'Proof of Product Procurement',
      }
    },
    blMgmt: {
      search: {
        blNo: 'B/L No.',
        shipmentDate: 'Shipment Departure Date',
        conveyance: 'Vessel/Voyage No.',
        status: 'Confirmation Status',
        invoiceNo: 'Proforma Invoice No.',
        batchSearch: 'Bulk Search'
      },
      table: {
        invoiceNo: 'Proforma Invoice No.',
        blNo: 'B/L No.',
        shipmentDate: 'Shipment Departure Date',
        conveyance: 'Vessel/Voyage No.',
        status: 'Confirmation Status',
        confirmTime: 'Confirmation Time',
        creator: 'Creator',
        creationTime: 'Creation Time'
      },
      actions: {
        importInfo: 'Import B/L data',
        uploadFiles: 'Batch Upload B/L',
        validateConfirm: 'Confirm',
        deleteData: 'Delete Data',
        deleteFiles: 'Delete Files',
        withdraw: 'Withdraw',
        export: 'Export'
      },
      dialog: {
        systemTip: 'System Notification',
        batchSearch: 'Bulk Search',
        byInvoice: 'By Proforma Invoice No.',
        byBL: 'By B/L No.',
        inputPlaceholder: 'Please enter separated by lines or commas (,)',
        confirmMsg: 'The confirmed data and documents will be used in all stages of import and export applications. Please ensure they are correct.',
        withdrawMsg: 'Are you sure you want to withdraw the following info and documents?',
        deleteFileMsg: 'The following B/L numbers are already confirmed and cannot be deleted. To update, please withdraw them first.',
        ftaLimitMsg: 'The following Invoice No. has started FTA certification and cannot be withdrawn.',
        selfCheck: 'Self-check Tips',
        selfProject: 'Check Item',
        systemCalc: 'System Calc',
        userCalc: 'User Entry',
        selfResult: 'Result',
        index: 'No.'
      }
    },
    cooMgmt: {
      title: 'COO Mgmt.',
      search: {
        certNo: 'Certificate No.',
        invoiceNo: 'Proforma Invoice No.',
        commercialInvNo: 'Commercial Invoice No.',
        submissionTime: 'Application Time'
      },
      actions: {
        add: 'Add',
        validateConfirm: 'Confirm',
        delete: 'Delete',
        batchUploadCert: 'Batch Upload Certificate (PDF)',
        UploadLog: 'Upload Log',
        uploadCert: 'Upload Certificate (PDF)',
        uploadTracking: 'Upload Express Tracking No.',
        manageTracking: 'Maintain Express Tracking No.',
        batchSave: 'Batch Save',
        export: 'Export',
        sendEmailToImporter:'邮件通知进口方',
        sendEmailToMYS:'马来西亚',
        sendEmailToIDN:'印度尼西亚',
        sendEmailToVNM:'越南',
      },
      table: {
        status: 'Status',
        customsReceipt: 'Customs Receipt',
        receipt:'Accompanying Document Receipt',
        certNo: 'Certificate No.',
        commercialInvNo: 'Commercial Invoice No.',
        proformaInvoiceNo: 'Proforma Invoice No.',
        signiId: 'SIGNI ID',
        blNo: 'B/L No.',
        certType: 'Certificate Type',
        trackingNo: 'Express Tracking No.',
        creationTime: 'Creation Time',
        submissionTime: 'Application Time',
        customsCert: 'FTA Certificate',
        hasDraftPdf: '草单文件',
        edit: 'Edit',
        saveToCustoms: 'Save to Customs',
        viewFile: 'View File'
      },
      dialog: {
        showReceipt:'Show Receipt',
        certTypeTitle: 'Certificate Type',
        receiptStatusTitle: 'Customs Receipt Status',
        systemTip: 'System Notification',
        missingFieldsMsg: 'The following certificates are missing required fields. Please complete them before validation.'
      },
      detail: {
        basicInformation: 'Basic Information',
        entityIdentificationCode: 'Entity Identification Code',
        companyNameInChinese: 'Company Name in Chinese',
        certificateNo: 'Certificate No.',
        commercialInvoiceNo: 'Commercial Invoice No.',
        invoiceDate: 'Invoice Date',
        departureDate: 'Departure Date',
        issuingAuthority: 'Issuing Authority',
        certificateCollectionAuthority: 'Certificate Collection Authority',
        placeOfApplication: 'Place of Application',
        dateOfApplication: 'Date of Application',
        declarantName: "Declarant's Name",
        declarantIdNo: "Declarant's ID No.",
        declarantContactDetails: "Declarant's Contact Details",
        importingCountryRegion: 'Importing Country/Region',
        exporter: 'Products Consigned From (Exporter’s Business Name, Address, Country)',
        consignee: 'Products Consigned To (Consignee’s Name, Address, Country)',
        exhibitionIndicator: 'Exhibition Indicator',
        marksAndNumbersOnPackages: 'Marks and Numbers on Packages',
        specialTermsAndConditions: 'Special Terms and Conditions',
        portOfLoading: 'Port of Loading',
        portOfDischarge: 'Port of Discharge',
        meansOfTransport: 'Means of Transport',
        vesselNameVoyageNo: 'Vessel Name / Voyage No.',
        exportTradeMethod: 'Export Trade Method',
        transitCountryRegion: 'Transit Country/Region',
        portOfTransshipment: 'Port of Transshipment',
        portOfDestination: 'Port of Destination',
        meansOfTransportAndRoute: 'Means of Transport and Route',
        applicationRemarks: 'Application Remarks',
        fobValueUsd: 'FOB Value (USD)',
        totalAmount: 'Total Amount',
        currency: 'Currency',
        specialInvoiceTerms: 'Special Invoice Terms',
        tradeTermsIncoterms: 'Trade Terms (Incoterms)',
        contractNo: 'Contract No.',
        letterOfCreditNo: 'Letter of Credit No.',
        thirdPartyInvoicingNonPartyCountryCompany: 'Third Party Invoicing / Company in a Non-Party Country',
        itemNumber: 'Item Number',
        countryRegion: 'Country/Region',
        companyName: 'Company Name',
        companyAddress: 'Company Address',
        goodsInformation: 'Goods Information',
        nonGoodsItemSelectYesForMixedGoods: 'Non-Goods Item (Select “Yes” for Mixed Goods)',
        hsCode: 'HS Code',
        nonOriginatingContent: 'Non-Originating Content (%)',
        productNameInChinese: 'Product Name in Chinese',
        productNameInEnglish: 'Product Name in English',
        descriptionOfProducts: 'Description of Products',
        originCriteria: 'Origin Criteria',
        originSubCriteria: 'Origin Sub-Criteria',
        supplementaryFieldForOriginCriteria: 'Supplementary Field for Origin Criteria',
        numberOfPackages: 'Number of Packages',
        quantityWeightUnit: 'Quantity / Weight Unit',
        supplementaryQuantityUnit: 'Supplementary Quantity / Unit',
        secondSupplementaryQuantityUnit: 'Second Supplementary Quantity / Unit',
        invoiceUnitPrice: 'Invoice Unit Price',
        invoiceAmountFob: 'Invoice Amount (FOB)',
        manufacturerCode: 'Manufacturer Code',
        manufacturerName: 'Manufacturer Name',
        contactPerson: 'Contact Person',
        contactPhoneNumber: 'Contact Phone Number'
      }
    },
    cooReceipt:{
      title: 'Accompanying Document',
      table: {
        fileName: 'File Name',
        note: 'File Transfer Result'
      }
    },
    cooTemplate: {
      title: 'COO Templates',
      search: {
        templateName: 'Template Name',
        status: 'Status'
      },
      actions: {
        add: 'Add',
        delete: 'Delete'
      },
      table: {
        templateName: 'Template Name',
        templateType: 'Template Type',
        creationTime: 'Creation Time',
        status: 'Status',
      }
    },
    tjpData: {
      title: 'TJP Data',
      search: {
        salesContract: 'noOfSalesContract',
        commercialInv: 'commercialInvoice',
        invDate: 'commercialInvDate',
        destCountry: 'destinationCountryId',
        creationTime: 'Creation Time',
        syncStatus: 'Data Synchronization Status',
        updateStatus: 'Data Update Status'
      },
      actions: {
        sync: 'Synchronize',
        export: 'Export'
      },
      table: {
        creationTime: 'Creation Time',
        updateStatus: 'Data Update Status',
        syncStatus: 'Data Synchronization Status',
        syncTime: 'Synchronization Time',
        details: 'Details',
        viewUpdates: 'View Updates'
      },
      dialog: {
        systemTip: 'System Notification',
        syncIneligibleMsg: 'The following Proforma Invoice numbers do not meet synchronization requirements (Destination: MY; Trade Mode: 0110). Please contact operations.',
        syncDuplicateMsg: 'The following invoices already have certificates. To re-sync, please delete existing COO data first.',
        syncConfirmMsg: 'Are you sure you want to sync the selected {count} TJP data records to the Declaration page?',
        updateTitle: 'Data Updates (Compared to Previous Version)',
        fieldPosition: 'Field Position',
        lineNumber: 'Line No.',
        fieldName: 'Field Name',
        newData: 'New Data',
        originalData: 'Original Data'
      }
    }
  }

};
